import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

const AdminUserDetails = ({ user }) => {
  const name = user.firstName ? `${user.firstName} ${user.lastName}` : user.screenName;

  const coordinates =
    user.address && user.address.coordinates ? (
      <a
        className="link"
        target="_blank"
        href={`http://www.google.com/maps/place/${user.address.coordinates.lat},${user.address.coordinates.lon}`}
      >
        Google Maps
      </a>
    ) : (
      ''
    );

  const phoneNumber = user.phoneNumber ? (
    <a className="link" href={`tel:${user.phoneNumber}`}>
      {user.phoneNumber}
    </a>
  ) : (
    ''
  );

  const email = user.contact ? (
    <a className="link" href={`mailto:${user.contact}`}>
      {user.contact}
    </a>
  ) : (
    ''
  );

  const address = user.address ? (
    <div className="admin__user-profile-address">
      <div className="m-b-1">🚚 {coordinates}</div>
      <div className="">
        <strong>
          <FormattedMessage id={'order.view.user.address.street'} />
        </strong>
        : {user.address.street}
      </div>
      <div className="">
        <strong>
          <FormattedMessage id={'order.view.user.address.unit'} />
        </strong>
        : {user.address.unit}
      </div>
      <div className="">
        <strong>
          <FormattedMessage id={'order.view.user.address.post.code'} />
        </strong>
        : {user.address.postCode}
      </div>
      <div className="">
        <strong>
          <FormattedMessage id={'order.view.user.address.city'} />
        </strong>
        : {user.address.city}
      </div>
      <div className="">
        <strong>
          <FormattedMessage id={'order.view.user.address.country'} />
        </strong>
        : {user.address.countryName}
      </div>
    </div>
  ) : (
    <p>
      <FormattedMessage id={'order.view.user.address.no.address'} />
    </p>
  );

  return (
    <div className="admin__user m-b-5">
      <div className="admin__user-profile m-b-6">
        <div
          className="admin__user-profile-avatar m-b-1"
          style={{ backgroundImage: `url("${user.avatar.thumbnailImage}")` }}
        />

        <Link to={`/admin/users/${user.id}`}>
          <h4 className="admin__user-profile-name">
            #{user.id} {name}
          </h4>
        </Link>

        <div className="m-b-2">
          <Link to={`/user/edit/${user.id}`} className="link">
            Edit profile
          </Link>
        </div>

        {address}

        <div className="">
          <strong>
            <FormattedMessage id={'order.view.user.phone.number'} />
          </strong>
          : {phoneNumber}
        </div>
        <div className="">
          <strong>
            <FormattedMessage id={'order.view.user.contact'} />
          </strong>
          : {email}
        </div>
        <div className="text-muted">
          <small>
            <strong>
              <FormattedMessage id={'order.view.user.email'} />
            </strong>
            : {user.email}
          </small>
        </div>
      </div>
    </div>
  );
};

AdminUserDetails.propTypes = {
  user: PropTypes.object.isRequired,
  currentUser: PropTypes.object,
};

AdminUserDetails.defaultProps = {};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default injectIntl(connect(mapStateToProps)(AdminUserDetails));
